import React, { useState, useRef } from 'react'

export default function Cost({currency, value, priceEditable, onChange}) {
  const [editCost, setEditCost] = useState(false)
  const costInputRef = useRef(null)
  const currencyName = currency == 'usd' ? '' : ` (${currency.toUpperCase()})`

  const changeCost = () => {
    const newCost = parseFloat(costInputRef.current.value) || 0
    if (newCost < 0 || newCost > 1000000) return

    onChange(newCost)
    setEditCost(false)
  }

  return <div className='panel panel-info new-reservation-cost-panel'>
    <div className='panel-heading'>{`Total Price${currencyName}:`}</div>
    <div className='panel-body'>
      { !editCost &&
        <div className='toggle-cost-edit'>
          <span className='total-reservation-cost'>$ {value}</span>&nbsp;
          { priceEditable && <span className='fa fa-pencil' onClick={() => setEditCost(true)}></span> }
        </div>
      }
      { editCost &&
        <form>
          <div className='dollar-field inline'>
            <input step='0.01' className='form-control' type='number' 
              autoFocus ref={costInputRef} onBlur={() => setTimeout(() => { setEditCost(false) }, 300)} />
          </div>&nbsp;
          <input type='submit' name='commit' value='OK' className='btn btn-info' 
            onClick={(e) => {e.preventDefault(); changeCost()}} />
        </form>
      }
    </div>
  </div>
}
